export const CLEAR_PREVIOUS_LOCATION = "CLEAR_PREVIOUS_LOCATION";
